import isExperienceEditor from "@utils/is-experience-editor";

var VCA = VCA || {};


VCA.PillFilters = (function ($) {

    var ui = {};

    function cacheUI() {
        ui.$body = $('body');
        ui.$pillSlider = $('.js-filter-slider');
    }

    function init() {
        cacheUI();
        bindFilterClick();
        bindPillFilterSlider();
    }

    function bindFilterClick() {
        $('.filterOptions li a').on('click', function (e) {
            e.preventDefault();
            filterValue = $(this).data('filter');
            $('.grid li').fadeOut().promise().done(function () {
                $('.grid li.' + filterValue).fadeIn();
            });

            if ($(this).hasClass('all')) {
                $('.grid li').fadeOut().promise().done(function () {
                    $('.grid li').fadeIn();
                });
            }
        });
    }

    function bindPillFilterSlider() {
        var pillSlider = ui.$pillSlider.each(function (index, element) {
            $(this).addClass('js-filter-slider' + index);
            var item_length = $('.js-filter-slider' + index + ' > div').length;
            if(item_length > 1 && !isExperienceEditor) {
                $('.js-filter-slider' + index).slick({
                    variableWidth: true,
                    autoplay: false,
                    infinite: false,
                    speed: 100,
                    arrows: true,
                    dots: false,
                    slidesToScroll: 1,
                    outerEdgeLimit: true,
                    draggable: true,
                    swipeToSlide: true
                });
            }
        });
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.PillFilters.init();
});